import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { DxDropDownButtonComponent } from "devextreme-angular";
import { ItemClickEvent } from "devextreme/ui/list";
import { Properties } from "devextreme/ui/popup";
import { FilterValue } from "src/app/home/demo-portfolio/demo-portfolio.service";

export interface UpdateSelecteItems {
  value: FilterValue;
  action: "ADD" | "REMOVE";
}

@Component({
  selector: "brd-filter-dropdown",
  templateUrl: "./filter-dropdown.component.html",
  styleUrl: "./filter-dropdown.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FilterDropdownComponent implements OnInit {
  @Input() items: FilterValue[] = [];
  @Input() selectedItems: number[] = [];
  @Input() filterName: string;
  @Input() displayExpr: string = "name";
  @Input() keyExpr: string = "id";
  @Input() chipColor: string = "#32BEF0";
  @Input() width: string = "200px";
  @Input() popupWidth: string = "240px";
  @Output() updateSelectedItems = new EventEmitter<UpdateSelecteItems>();

  @ViewChild("dropdownButton") dropdownButton: DxDropDownButtonComponent;
  @ViewChild("popupContainer", { static: true }) popupContainer: ElementRef;

  protected searchPlaceholder = "";
  protected dropDownOptions: Properties;

  constructor(private elRef: ElementRef) {}

  ngOnInit(): void {
    this.searchPlaceholder = `Search ${this.filterName}`;
    this.dropDownOptions = {
      container: this.popupContainer.nativeElement,
      width: this.popupWidth,
      maxHeight: 450,
      wrapperAttr: { class: "filter-dropdown" },
      position: {
        of: this.elRef.nativeElement,
        at: "left bottom",
        my: "left top",
        offset: "0 10",
        collision: "fit"
      }
    };
  }

  clickItem({ itemData }: ItemClickEvent): void {
    this.updateSelectedItems.emit({ value: itemData, action: this.selectedItems.includes(itemData.id) ? "REMOVE" : "ADD" });
  }
}
